const UNPAID = "UNPAID";
const PENDING = "PENDING";
const PAID = "PAID";
const VOID = "VOID";
const DRAFT = "DRAFT";
const DELETED = "DELETED";
const EXPIRED = "EXPIRED";

export { UNPAID, PENDING, PAID, VOID, DRAFT, DELETED, EXPIRED };
